<template>
    <HomeLayout :isShowDelivery="false" :hideMainFooterMobile="true">
        <template v-if="!showNoResult">
            <div
                class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8 my-4 lg:my-8 mx-4 lg:mx-0">
                <CampaignItem v-for="(campaign) in items" :key="campaign.id" :campaign="campaign"></CampaignItem>
            </div>
        </template>
        <template v-else>
            <div class="mt-40">
                <img src="@/assets/image/foods.svg" class="mx-auto lg:h-25 w-auto" />
                <div class="text-a-brown-9f8273 text-14 lg:text-16 font-main text-center mt-2 lg:mt-6">
                    Couldn't Find Results for <span class="text-a-brown-502314">
                        "{{ searchTerm }}"
                    </span>
                </div>
            </div>
        </template>
    </HomeLayout>
</template>
<script>
import { computed, inject, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useCampaignList } from "@/module/List/composable/useCampaignList"
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import useScroll from "@/helper/composable/useScroll"
import useDelivery from "../composable/useDelivery"

// helper
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
// component
import HomeLayout from '@/components/Layout/Page/HomeLayout.vue';
import CampaignItem from '@/module/Home/component/CampaignListHome/CampaignItem.vue';

//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'


export default {
    name: 'SearchPage',
    components: {
        HomeLayout,
        CampaignItem
    },
    mixins: [AuthStatusMixin],
    data: function () {
        return {
            dashboardHomeConfig: null,
            cateHomeConfig: null,
        };
    },
    setup: function () {
        const SearchStore = inject("SearchStore")
        const modalStore = inject("ModalStore")
        const { showLoadingModal, hideLoadingModal } = useLoadingModal(modalStore)
        const route = useRoute()
        const scrollService = useScroll()
        const delivery = useDelivery()
        const { items, events, loadMore, getList, setSearch, resetConfig } = useCampaignList(ConfigManager.getCampaignSearchConfig(delivery.tier.value))
        const searchTerm = ref("")
        const showNoResult = computed(() => {
            if (searchTerm.value != "" && items.value.length == 0) {
                return true
            }

            return false
        })

        events.onLoading = showLoadingModal
        events.onLoaded = hideLoadingModal
        scrollService.event.onBottom = loadMore


        watch(() => route.query.q, (q) => {
            if (!Util.isEmptyStr(q)) {
                searchTerm.value = q
                Util.scrollTop()
                setSearch(q)
                getList()
            }
        })

        onMounted(() => {
            searchTerm.value = route.query?.q ?? ""
            setSearch(searchTerm.value)
            getList()
            scrollService.init()

            setTimeout(() => {
                Util.scrollTop()
            }, 500);

            SearchStore.on("clear").subscribe(() => {
                searchTerm.value = ""
                resetConfig()
            })
            SearchStore.on("search").subscribe(() => {
                // search same word as q on route.query
                searchTerm.value = route.query?.q
                resetConfig()
                getList()
            })
        })

        return {
            searchTerm,
            items,
            showNoResult
        }
    },
}
</script>
